import Dialog from "@mui/material/Dialog";
import CompanyCrud from "./CompanyCrud";

// This just wraps the CompanyCrud component, to allow using it as a separate Dialog
// without DotMenu or SpeedMenu. This is needed in cases when there are multiple dialogs,
// that do not use the url to determine if it's open. Dot/SpeedMenu can only close
// by using the url and reloading the page.
export default function CompanyCrudDialog({ open, companyCrudProps, zIndexOverride }) {
  return (
    <Dialog
      maxWidth={false}
      className="stdDialog"
      scroll="paper"
      onClose={companyCrudProps.onCancel ?? companyCrudProps.onClose}
      open={open}
      sx={zIndexOverride ? { zIndex: zIndexOverride } : {}}
    >
      <CompanyCrud {...companyCrudProps} parentZIndexOverride={zIndexOverride} />
    </Dialog>
  );
}
